var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInfosSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3824 15.1318C18.2605 15.137 18.1379 15.1395 18.0147 15.1395C13.3447 15.1395 9.55882 11.4277 9.55882 6.84884C9.55882 6.22988 9.628 5.62676 9.75919 5.04651H3.67647C1.64601 5.04651 0 6.66037 0 8.65116V27.3953C0 29.3861 1.64601 31 3.67647 31H14.7059C16.7363 31 18.3824 29.3861 18.3824 27.3953V15.1318Z",
    fill: "#2D4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0147 13.6977C21.8726 13.6977 25 10.6313 25 6.84884C25 3.06633 21.8726 0 18.0147 0C14.1568 0 11.0294 3.06633 11.0294 6.84884C11.0294 10.6313 14.1568 13.6977 18.0147 13.6977ZM19.226 9.483H20.7014L18.7985 6.78091L20.6008 4.21467H19.226L18.0692 5.99594H18.044L16.904 4.21467H15.4203L17.2058 6.75826L15.3281 9.483H16.7028L17.9351 7.54323H17.9602L19.226 9.483Z",
    fill: "#2D4040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInfosSection);
export default __webpack_public_path__ + "static/media/noInfosSection.cc32e8abf9eb84497db2528dfa8969f4.svg";
export { ForwardRef as ReactComponent };